import { AddEvent, ClickEvent, DeleteEvent, ViewEvent } from '~/passporter-services/shared/metrics'
import { BaseMetric } from './baseMetric'
import mixpanel from 'mixpanel-browser'
import { ProfileDestination } from '~/models/ProfileDestination'

export class ProfileMetric extends BaseMetric {
	static viewEditDialog(): void {
		const routeName: string = 'profile'
		new ViewEvent('settings', routeName).send(this.gtag, mixpanel)
	}

	static viewStamps(routeName: string): void {
		new ViewEvent('stamps', routeName).send(this.gtag, mixpanel)
	}

	static viewStats(routeName: string): void {
		new ViewEvent('stats', routeName).send(this.gtag, mixpanel)
	}

	static viewProfileDestination(element: string, routeName: string): void {
		new ViewEvent(`stats - ${element}`, routeName).send(this.gtag, mixpanel)
	}

	public static addProfileDestination(destination: ProfileDestination) {
		const routeName: string = 'profile'
		const eventName = destination.type === 'visited' ? 'visited destination' : 'wished destination'
		new AddEvent(eventName, routeName)
			.id(destination.destinationId)
			.destination(destination.name.toLowerCase())
			.send(this.gtag, mixpanel)
	}

	public static addProfileDestinations(destinations: ProfileDestination[]) {
		destinations.forEach((destination) => this.addProfileDestination(destination))
	}

	public static deleteProfileDestination(destination: ProfileDestination) {
		const routeName: string = 'profile'
		const eventName = destination.type === 'visited' ? 'visited destination' : 'wished destination'
		new DeleteEvent(eventName, routeName)
			.id(destination.destinationId)
			.destination(destination.name.toLowerCase())
			.send(this.gtag, mixpanel)
	}

	static shareProfileDestination(element: string, routeName: string): void {
		new ClickEvent(`share stats - ${element}`, routeName).send(this.gtag, mixpanel)
	}
}
